import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Checkbox from '../checkbox';
import ParentCheckbox from '../parent-checkbox';
import HelpText from '../__partials/help-text';
import giveWarning from '../../__utils/warning';

class CheckboxGroup extends React.Component {
  render() {
    const {
      children,
      header,
      valuesChecked,
      required,
      disabled,
      hasError,
      helpText,
      hideHeader,
      hasDivider,
      onChange,
      className,
      qaId,
    } = this.props;

    const formItemClasses = classNames('uni-form__item', 'l-grid__item', {
      'uni-form__item--is-error': hasError,
      'uni-form__item--is-disabled': disabled,
      'uni-form__item--has-divider': hasDivider,
      [className]: className,
    });

    const options = React.Children.map(children, option => {
      if (option.type === ParentCheckbox) {
        return (
          <ParentCheckbox
            {...option.props}
            onChange={onChange.bind(null, option.props.value)}
            disabled={disabled || option.props.disabled}
          >
            {option.props.children}
          </ParentCheckbox>
        );
      } else if (option.type === Checkbox) {
        if (option.props.checked) {
          giveWarning('To set the checked checkboxes, use CheckboxGroups `valuesChecked` array.');
        }
        return (
          <Checkbox
            {...option.props}
            checked={valuesChecked.indexOf(option.props.value) >= 0}
            disabled={disabled || option.props.disabled}
            onChange={onChange}
          >
            {option.props.children}
          </Checkbox>
        );
      }
      return null;
    });

    return (
      <div className={formItemClasses} data-qa-id={qaId}>
        <fieldset className="uni-form__check-group">
          {hideHeader ? null : (
            <h4 className="uni-form__check-header">
              {header}
              {required ? <span className="uni-form__required" /> : null}
            </h4>
          )}
          {options}
        </fieldset>
        {helpText ? <HelpText text={helpText} /> : null}

      </div>
    );
  }
}

CheckboxGroup.propTypes = {
  children: PropTypes.node,
  header: PropTypes.string,
  valuesChecked: PropTypes.array,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
  helpText: PropTypes.string,
  hideHeader: PropTypes.bool,
  hasDivider: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
  qaId: PropTypes.string,
};

CheckboxGroup.defaultProps = {
  valuesChecked: [],
  required: false,
  disabled: false,
  hideHeader: false,
  hasDivider: false,
  onChange: () => { },
};

export default CheckboxGroup;



// WEBPACK FOOTER //
// ./src/forms/checkbox-group/index.jsx